
const configMapping = {
  version1: {
    id: "version1",
    requiredFields: ["deliveryDate", "numberOfPeople"],
    itemPriceFieldTTC: "Prix de vente TTC",
    itemPriceFieldHT: "Prix de vente HT",
    deliveryCost: 70,
    deliveryFreeThreshold: 250,
    discount: 0,
    partnerCommissionRate: 0,
    applyDeliveryFee: true,
    applyPartnerDiscount: true,
    showDeliveryFeeInSummary: true,
    showPartnerDiscountInSummary: true,
    noCheckout: false,
  },
  version2: {
    id: "version2",
    requiredFields: ["deliveryDate", "email", "lastName", "numberOfPeople"],
    itemPriceFieldTTC: "Prix de vente TTC",
    itemPriceFieldHT: "Prix de vente HT",
    deliveryCost: 70,
    deliveryFreeThreshold: 250,
    discount: 0,
    partnerCommissionRate: 0,
    applyDeliveryFee: true,
    applyPartnerDiscount: false,
    showDeliveryFeeInSummary: true,
    showPartnerDiscountInSummary: false,
    noCheckout: false,
  },
  version3: {
    id: "version3",
    requiredFields: ["deliveryDate", "email", "lastName", "numberOfPeople"],
    itemPriceFieldTTC: "Prix de vente TTC",
    itemPriceFieldHT: "Prix de vente HT",
    deliveryCost: 70,
    deliveryFreeThreshold: -1,
    discount: 0,
    partnerCommissionRate: 0,
    applyDeliveryFee: true,
    applyPartnerDiscount: false,
    showDeliveryFeeInSummary: true,
    showPartnerDiscountInSummary: false,
    noCheckout: false,
  },
  version4: {
    id: "version4",
    requiredFields: ["deliveryDate", "email", "lastName", "numberOfPeople"],
    itemPriceFieldTTC: "Prix de vente TTC",
    itemPriceFieldHT: "Prix de vente HT",
    deliveryCost: 70,
    deliveryFreeThreshold: 250,
    discount: 0,
    partnerCommissionRate: 0,
    applyDeliveryFee: true,
    applyPartnerDiscount: false,
    showDeliveryFeeInSummary: true,
    showPartnerDiscountInSummary: false,
    noCheckout: false,
  },
  versionNoCheckout: {
    id: "versionNoCheckout",
    noCheckout: true,
    requiredFields: ["deliveryDate", "email", "lastName", "numberOfPeople"],
    itemPriceFieldTTC: "Prix de vente TTC",
    itemPriceFieldHT: "Prix de vente HT",
    deliveryCost: 70,
    deliveryFreeThreshold: 250,
    discount: 0,
    partnerCommissionRate: 0,
    applyDeliveryFee: true,
    applyPartnerDiscount: false,
    showDeliveryFeeInSummary: true,
    showPartnerDiscountInSummary: false,
  },
};

const subdomainToConfig = {
  wxd: "version3",
  b5d: "version2",
  jc5: "version1",
  eue: "version2",
  bh0: "version1",
  nwd: "version1",
  r3f: "version2",
  a3f: "version1",
  yr9: "version1",
  ci8: "version1",
  cj9: "version1",
  o4t: "version1",
  ke2: "version2",
  hm6: "version2",
  l1v: "version2",
  t7u: "version1",
  vk9: "version2",
  p1m: "version1",
  noc: "versionNoCheckout",
};

const subdomainEmail = {
  wxd: "charter@prestigiousyachting.com",
  b5d: "a@yachtside.mc",
  jc5: "daycharter@arthaudyachting.com",
  eue: "marion@excellenceriviera.com",
  bh0: "info@livenupyachtcharter.com",
  nwd: "charter@mercurio.fr",
  r3f: "officefrance@wajer.com",
  a3f: "tom@pelagiayachting.com",
  yr9: "m.patural@med-yacht.com",
  ci8: "sebastien@luxuryrent.fr",
  cj9: "contact@algayacht.com",
  o4t: "charter@aresyachtingservices.com",
  ke2: "stephane@ang.fr",
  hm6: "katia@houseboat-info.com",
  l1v: "charter@lacoche-yacht.com",
  t7u: "contact@top-charter.com",
  vk9: "teus@lalmycare.com",
  p1m: "contact@aliceboat.com",
  noc: "contact@labelle-table.com",
};

export { configMapping, subdomainEmail, subdomainToConfig };
